const supportedOptions = {
    headers: () => 'headers',
    expires: () => 'ttl',
    timeout: () => 'timeout',
    method: () => 'method',
    redirect: (target, val) => {
        switch (val) {
            case 'manual':
                target.followAllRedirects = false;
                target.followRedirect = false;
                return; 
            case 'follow':
            default:
                target.followAllRedirects = true;
                target.followRedirect = true;
                return;
        }
        return;
    },
    referrer: (target, val) => {
        if (val === 'no-referrer') {
            target.removeRefererHeader = true;
        }
        return;
    }
};

module.exports = function fetchConfigToRequestConfigAdapter (fetchConfig = {}) {
    const requestConfig = {};
    Object.keys(fetchConfig).forEach( (key) => {
        if (key in supportedOptions) {
            const temp = supportedOptions[key](requestConfig, fetchConfig[key]);
            // If we get a return key from the opts, map
            // the fetchConfig value to requestConfig
            if (temp !== undefined) {
                requestConfig[temp] = fetchConfig[key];
            }
        }
    });

    return requestConfig;
}